import { SagaIterator } from 'redux-saga';
import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import { MCAFirebaseSaga } from '../root-saga';
import {
  GET_PREFERENCES,
  UpdatePreferencesAction,
  UPDATE_PREFERENCES,
  GET_SETTINGS,
  Settings,
  SEND_CONTACT_FORM,
  SendContactUsForm,
  CHANGE_ACCOUNT_TYPE,
} from './types';
import { CreateProfileAction, UPDATE_PROFILE } from '../user/types';
import { getUserState } from '../user/selector';
import { setError, setLoading } from '../app-globals/actions';
import { setPreferences, getPreferences, setSettings } from './actions';
import { firestore } from '../../constants/firebase';
import { FirestoreSnapshot } from '../meals/types';
import { syncUser } from '../user/actions';

function* fetchSettings(): SagaIterator<void> {
  try {
    const settingsRef = firestore.collection('settings').limit(1);
    const snapshot = yield call(
      MCAFirebaseSaga.firestore.getCollection,
      settingsRef
    );
    const settings: Settings = {
      terms: '',
      termscz: '',
      termsit: '',
      aboutus: '',
      faqs: [],
    };
    snapshot.forEach((item: FirestoreSnapshot) => {
      settings.terms = item.data().terms;
      settings.termscz = item.data().terms_cz;
      settings.termsit = item.data().terms_it;
      settings.aboutus = item.data().aboutus;
      settings.faqs = item.data().faqs;
    });
    yield put(setSettings(settings));
  } catch (e) {}
}

function* fetchPreferences(): SagaIterator<void> {
  try {
    const { user } = yield select(getUserState);
    const preferences = yield call(
      MCAFirebaseSaga.firestore.getDocument,
      `preferences/${user.userid}`
    );
    yield put(setPreferences(preferences.data()));
  } catch (e) {
    yield put(setError(true, e.message));
  }
}

function* updatePreferences({
  preferences,
}: UpdatePreferencesAction): SagaIterator<void> {
  try {
    const { user } = yield select(getUserState);
    yield call(
      MCAFirebaseSaga.firestore.updateDocument,
      `preferences/${user.userid}`,
      preferences
    );

    yield put(getPreferences());
  } catch (e) {}
}

function* sendContactForm({ form }: SendContactUsForm) {
  try {
    yield put(setLoading(true, 'Sending Contact Form'));
    const sendFormResult = yield call(
      MCAFirebaseSaga.functions.call,
      'sendContactUsForm',
      form,
      {
        method: 'POST',
      }
    );
    yield put(setLoading(false, ''));
    console.log('sendFormResult', sendFormResult);
  } catch (e) {
    yield put(setLoading(false, ''));
  }
}

function* updateProfile({ details }: CreateProfileAction): SagaIterator<void> {
  try {
    yield put(setLoading(true, 'Updating User'));
    const user = yield select(getUserState);
    // console.log(user.user.image === details.image);
    if (details.image !== user.user.image) {
      const randomGenerator = Math.random()
        .toString(36)
        .substring(2);
      const imageFilename = 'IMG_' + randomGenerator.toUpperCase() + Date.now();
      const task = yield call(
        MCAFirebaseSaga.storage.uploadString,
        imageFilename,
        details.image,
        'data_url',
        { contentType: 'image/jpeg' }
      );

      yield task; // waiting to upload

      const imageUrl = yield call(
        MCAFirebaseSaga.storage.getDownloadURL,
        imageFilename
      );
      delete details.image;
      const body = {
        username: details.username,
        description: details.description,
        image: imageUrl,
        phone: details.phone,
        address: details.address,
        accountType: user.user.accountType === 'i offer' ? 'i seek' : 'i offer',
        subAccountType: user.user.accountType,
        location: details.location,
      };
      yield call(
        MCAFirebaseSaga.firestore.setDocument,
        `users/${user.user.userid}`,
        body,
        {
          merge: true,
        }
      );
    } else {
      delete details.image;
      // delete details.location;
      const body = {
        username: details.username,
        description: details.description,
        phone: details.phone,
        accountType: user.user.accountType === 'i offer' ? 'i seek' : 'i offer',
        subAccountType: user.user.accountType,
        address: details.address,
        location: details.location,
      };
      yield call(
        MCAFirebaseSaga.firestore.setDocument,
        `users/${user.user.userid}`,
        body,
        {
          merge: true,
        }
      );
    }
    yield put(syncUser());
    yield put(setLoading(false, 'Profile Updated'));
    window.location.replace('/profile');
  } catch (e) {
    yield put(setLoading(false, ''));
  }
}

function* changeAccountType(): SagaIterator<void> {
  const { user } = yield select(getUserState);
  try {
    yield put(setLoading(true, 'Updating User'));
    const body = {
      accountType: user.accountType === 'i offer' ? 'i seek' : 'i offer',
      subAccountType: user.accountType,
    };
    yield call(
      MCAFirebaseSaga.firestore.setDocument,
      `users/${user.userid}`,
      body,
      {
        merge: true,
      }
    );
    yield put(syncUser());
    yield put(setLoading(false, ''));
    window.location.reload();
  } catch (e) {
    console.log(e);
    yield put(setLoading(false, ''));
  }
}

export function* SettingsSaga() {
  yield all([
    takeLatest(GET_PREFERENCES, fetchPreferences),
    takeLatest(UPDATE_PREFERENCES, updatePreferences),
    takeLatest(GET_SETTINGS, fetchSettings),
    takeLatest(SEND_CONTACT_FORM, sendContactForm),
    takeLatest(UPDATE_PROFILE, updateProfile),
    takeLatest(CHANGE_ACCOUNT_TYPE, changeAccountType),
  ]);
}
